export default "__VITE_PUBLIC_ASSET__d2bba6a6__"